import { render, staticRenderFns } from "./WebsiteBuilder.vue?vue&type=template&id=cdccd8be&scoped=true"
import script from "./WebsiteBuilder.vue?vue&type=script&lang=js"
export * from "./WebsiteBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdccd8be",
  null
  
)

export default component.exports